<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警接收人配置
        </span>
        <normalNav :parent="self">
          <button class="GreenSmBtn" @click="$refs.userDialog.addnew()">
            新增
          </button>
        </normalNav>
        <!-- </div> -->
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_jsgl"
            ref="searchForm_jsgl"
          ></searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="operation/alertEmp/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_jsgl"
          >
            <template slot="last">
              <el-table-column
                label="通知方式"
                prop="infromType"
                :formatter="statusSymbol"
              ></el-table-column>
            </template>
            <template slot="last">
              <el-table-column label="操作" width="200" align="left">
                <template slot-scope="scope">
                  <!-- <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="$refs.userDialog.edit(scope.$index, scope.row)"
                    >编辑</el-link
                  > -->
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                    >删除</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <add-dialog ref="userDialog"></add-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      tabName: "jsgl",
      other: {},
      form_jsgl: {},
      items: [
        {
          type: "input",
          prop: "name",
          label: "用户姓名",
          placeholder: "请输入用户姓名",
          option: {},
        },
        {
          type: "input",
          prop: "phone",
          label: "用户手机",
          placeholder: "请输入用户手机",
          option: {},
        },
      ],
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "姓名",
        },
        {
          prop: "userPhone",
          label: "手机号码",
        },
        {
          prop: "deptName",
          label: "部门",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    easyTable: () => import("public/easyTable"),
    searchForm: () => import("public/searchForm"),
    addDialog: () => import("./addDialog"),
  },
  methods: {
    getInfo() {
      this.$refs.table_jsgl.getData();
    },
    statusSymbol(row, column) {
      if (row.infromType === 0) {
        return "无";
      } else if (row.infromType === 1) {
        return "短信";
      } else if (row.infromType === 2) {
        return "语音";
      } else if (row.infromType === 3) {
        return "短信加语音";
      }
    },
    reset_jsgl(fn) {
      fn();
      this.form_jsgl = {};
    },
    search_jsgl(fn) {
      fn();
    },
    //删除
    deleteMsg(index, row) {
      //console.log(row);
      this.$confirm("是否删除该用户", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axiosdelete("operation/alertEmp/delete", {
          params: {
            id: row.id,
          },
        }).then((res) => {
          if (res.data.status === 10000) {
            this.$refs.table_jsgl.getData();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/configuration/alarmPerson.vue